import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const assignSchedulesToTrade = api(async function assignSchedulesToTrade({ skillMapId, tradeId, targets }) {
    return mutate(
        gql`
            mutation AssignSchedulesToTrade(
                $skillMapId: String!
                $tradeId: String!
                $targets: [ScheduleAssignmentTargetInput!]!
            ) {
                assignSchedulesToTrade(skillMapId: $skillMapId, tradeId: $tradeId, targets: $targets)
            }
        `,
        { skillMapId, tradeId, targets },
        { returns: "assignSchedulesToTrade" }
    )
})
